const luggage_lost = `Aihe: Valitus matkatavaroiden katoamisesta
Hyvä Finnairin asiakaspalvelu,
Kirjoitan ilmoittaakseni, että matkatavarani katosivat äskettäisen Finnairin lennon aikana.
Matkatavarani eivät ole saapuneet määränpäähän kanssani, ja tämä on aiheuttanut minulle paljon vaivaa.
Arvostan kiireellistä apuasi matkatavaroideni paikantamisessa ja sen nopean toimituksen varmistamisessa.
Matkatavaroiden sisältö on minulle tärkeä, ja haluan saada ne takaisin mahdollisimman pian.
Pyydän ystävällisesti pitämään minut ajan tasalla kaikista matkatavaroideni tilaa koskevista päivityksistä ja toimittamaan minulle aikataulun niiden toimittamiselle.
Luotan siihen, että Finnair ryhtyy tarvittaviin toimenpiteisiin asian ratkaisemiseksi nopeasti ja tehokkaasti.
Kiitos nopeasta huomiostasi tähän asiaan.
Ystävällisin terveisin,`;
export default luggage_lost;









